/* eslint-disable react/react-in-jsx-scope */
import {
  // BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import { AsideSupport } from '../../_layout/aside-support';
import { BoardView } from './boardView';
import { BoardWriter } from './boardWriter';
import { BooksAll } from './books-all';
import { Errata } from './errata';
import { Notice } from './notice';
import { Publish } from './publication';
import { Qna } from './qna';
import { ReferenceRoom } from './reference-room';
import { ReplyView } from './replyView';
import { ReplyWriter } from './replyWriter';
import { Search } from './search';

export function SupportMain() {
  return (
    <Switch>
      <>
        <Route path="/board/books-all" exact>
          <main className="sub list-books wrapper">
            <AsideSupport />
            <Route path="/board/books-all" exact component={BooksAll} />
          </main>
        </Route>
        <Route path="/board/boardWriter" exact>
          <main className="sub wrapper board-add">
            <AsideSupport />
            <Route path="/board/boardWriter" exact component={BoardWriter} />
          </main>
        </Route>

        <Route path="/board/boardView" exact>
          <main className="sub wrapper board-view">
            <AsideSupport />
            <Route path="/board/boardView" exact component={BoardView} />
          </main>
        </Route>

        <Route path="/board/replyView" exact>
          <main className="sub wrapper board-view">
            <AsideSupport />
            <Route path="/board/replyView" exact component={ReplyView} />
          </main>
        </Route>

        <Route path="/board/replyWriter" exact>
          <main className="sub wrapper board-add">
            <AsideSupport />
            <Route path="/board/replyWriter" exact component={ReplyWriter} />
          </main>
        </Route>

        <Route path="/board/notice" exact>
          <main className="sub list wrapper">
            <AsideSupport />
            <Route component={Notice} exact />
          </main>
        </Route>
        <Route path="/board/errata" exact>
          <main className="sub list wrapper">
            <AsideSupport />
            <Route component={Errata} exact />
          </main>
        </Route>
        <Route path="/board/lib" exact>
          <main className="sub list wrapper">
            <AsideSupport />
            <Route component={ReferenceRoom} exact />
          </main>
        </Route>
        <Route path="/board/qna">
          <main className="sub list wrapper">
            <AsideSupport />
            <Route component={Qna} exact />
          </main>
        </Route>
        <Route path="/board/publicationqna">
          <main className="sub list wrapper">
            <AsideSupport />
            <Route component={Publish} exact />
          </main>
        </Route>
        <Route path="/board/search/:keywords">
          <main className="sub list wrapper">
            <Route component={Search} exact />
          </main>
        </Route>
      </>
    </Switch>
  );
}
